import { LoadingSpinner } from 'components/ui/loading/spinner'
import Text from 'components/ui/text'
import { translate } from 'utils/translation'

interface PriceProps {
  billingCycle: string
  isLoading: boolean
  priceCurrency: string
  priceValue: string
  prefix?: string
}

export const Price = ({
  billingCycle,
  prefix,
  isLoading,
  priceCurrency,
  priceValue,
}: PriceProps) => {
  if (isLoading) {
    return <LoadingSpinner className="tw-stroke-orange" />
  }

  return (
    <Text
      as="span"
      className="tw-mt-2 tw-flex tw-items-center tw-gap-3 tw-text-4xl tw-font-bold lg:tw-text-5xl"
      renderChildren
    >
      {priceValue}
      <span className="tw-flex tw-flex-col">
        <Text
          as="span"
          className="tw-text-sm tw-font-black tw-uppercase"
          renderChildren
        >
          {priceCurrency}
          {!!billingCycle && (
            <Text
              as="span"
              className="tw-text-xs tw-font-normal tw-lowercase lg:tw-text-sm "
              renderChildren
            >
              /{translate(billingCycle)}
            </Text>
          )}
        </Text>
        {prefix && (
          <Text
            as="span"
            className="tw-text-xs tw-font-normal tw-text-zinc-600 lg:tw-text-sm"
          >
            {prefix}
          </Text>
        )}
      </span>
    </Text>
  )
}
